module.exports = __webpack_public_path__ + "img/fig20.c8d57270.jpg";